"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactNode, useEffect, useState } from "react";
import { useAuthStore } from "@/store/auth-store";
import { useActiveClientStore } from "@/store/active-client-store";
import { RelatedEntityNavigationProvider } from "@/components/navigation/related-entity-navigation";

interface ProvidersProps {
  children: ReactNode;
}

function AuthInitializer() {
  const initialize = useAuthStore((state) => state.initialize);

  useEffect(() => {
    void initialize();
  }, [initialize]);

  return null;
}

function ActiveClientInitializer() {
  const initialize = useActiveClientStore((state) => state.initialize);

  useEffect(() => {
    initialize();
  }, [initialize]);

  return null;
}

export function Providers({ children }: ProvidersProps) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <AuthInitializer />
      <ActiveClientInitializer />
      <RelatedEntityNavigationProvider>{children}</RelatedEntityNavigationProvider>
    </QueryClientProvider>
  );
}
